import { Link } from "react-router-dom";
import { actionProps } from "@/lib/controlAnalytics";
import type { Source } from "@/lib/api/catalogue";
import { companyOf, companyPath } from "@/lib/jobs/company";

/** The name and logo a company's page draws at once, sent with the link. */
export interface CompanyArrival {
    name: string;
    logoUrl: string | null;
}

/**
 * A company's name, leading to every job it has. Inside a card, whose own
 * press opens the posting, it keeps its press to itself.
 */
export default function CompanyLink({
    company,
    logoUrl,
    source,
    board,
    from,
    className = "",
}: {
    company: string;
    logoUrl: string | null;
    source: Source;
    board: string;
    /** Which part of the page it is on, for the analytics. */
    from: string;
    className?: string;
}) {
    const arrival: CompanyArrival = { name: company, logoUrl };
    return (
        <Link
            {...actionProps("company_jobs_clicked", { source: from, option: source })}
            to={companyPath(companyOf({ source, board }))}
            state={arrival}
            onClick={(event) => event.stopPropagation()}
            className={`underline decoration-line-strong underline-offset-[3px] hover:text-brand-ink hover:decoration-current ${className}`}
        >
            {company}
        </Link>
    );
}
